import React, { useEffect } from 'react';

const Register: React.FC = () => {
  useEffect(() => {
    window.location.href = 'https://shopline-frontend.pages.dev/register';
  }, []);
  return null;
};

export default Register;
